import type { SupportedLanguage } from '~/constants/languages';
import { apiClient } from '~/lib/apiClient';
import { convertLanguageToISO } from '~/src/services/i18n';

const buildFetchGachaIdInfoByUniqueNameQuery = (input: {
  i18nLn: SupportedLanguage | null;
}) => {
  const { i18nLn } = input;
  if (i18nLn === 'ja' || i18nLn == null) return {};
  const requestLang = convertLanguageToISO(i18nLn);
  return {
    query: {
      lang: requestLang,
    },
  };
};

export type FetchGachaIdInfoByUniqueNameParams = [
  string,
  string | null,
  SupportedLanguage | null,
];
export const fetchGachaIdInfoByUniqueName = async ([
  unique_name,
  token,
  i18nLn,
]: FetchGachaIdInfoByUniqueNameParams) => {
  const headers = token !== null ? { Authorization: `Bearer ${token}` } : {};
  const query = buildFetchGachaIdInfoByUniqueNameQuery({ i18nLn });

  const response = await apiClient.v1.gachas.by.unique_name
    ._uniqueName(unique_name)
    .get({ headers, ...query });
  return { gachaDetail: response.body, statusCode: response.status };
};
